import "../../styles/alerts/alert.css";
import { IoMdCloudUpload } from "react-icons/io";
import { syncOfflineQueue } from "../../tools/synOfflineQueue";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { ButtonLoader } from "../uxCollections/Loaders";
import { X, Upload, Download } from "lucide-react";
import { uiAlert } from "./customAlert/uiAlert";

/* const PromptToSync = ({ closeModal, must = null }) => {
  const [storeIsSyncing, setStoreIsSyncing] = useState(false);
  const [syncPercentage, setSyncPercentage] = useState("0%");
  const [initialCount, setInitialCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let initailCount = useRef(null); // to store the initial count of the queue

  const { count, _ } = useSelector((state) => state.offlineQueue);

  useEffect(() => {
    console.log(initailCount.current);

    if (initailCount.current === null) {
      console.log("setting initial count");

      initailCount.current = count;
    } else {
      let percentDegress = ((initailCount.current - count) / initailCount.current) * 100;
      setSyncPercentage(`${parseInt(Math.max(percentDegress, 0))}%`);
    }
  }, [count]);

  useEffect(() => {
    if (syncPercentage === "100%") {
      let prgressBar = document.querySelector(".prograssFIl");
      prgressBar.addEventListener("transitionend", () => {
        closeModal(false);
        setIsLoading(false);
      });
    }
  }, [syncPercentage]);

  const handleSyn = () => {
    setIsLoading(true);
    setStoreIsSyncing(true);
    syncOfflineQueue();
  };
  return (
    <div className='promptToSYnWrpaper'>
      <div className='promptDIv'>
        <img className='syncImage' src={require("../../assetsStatic/sync.png")} />
        <div className='syncCOunt'>
          {" "}
          <div></div>
          {must ? <p>{count} transactions must be synced before continuing</p> : <p>{count} transactions needs to sync</p>}
        </div>
        <div className='progressBarWrapper'>
          <div className='progressBarSync'>
            <div
              style={{
                width: `${syncPercentage}`,
              }}
              className='prograssFIl'
            ></div>
          </div>
          <p>synchronize {syncPercentage} </p>
        </div>
        {count ? (
          isLoading ? (
            <button style={{ opacity: "0.7" }} className='btnToSync'>
              <ButtonLoader />
            </button>
          ) : (
            <button onClick={handleSyn} className='btnToSync'>
              Synchronize transactions now <IoMdCloudUpload />
            </button>
          )
        ) : (
          <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='btnToSync'>
            Synchronize transactions now <IoMdCloudUpload />
          </button>
        )}
        {must ? (
          <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='btnToSyncII'>
            Do it later
          </button>
        ) : isLoading ? (
          <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='btnToSyncII'>
            Do it later
          </button>
        ) : (
          <button onClick={() => closeModal(false)} className='btnToSyncII'>
            Do it later
          </button>
        )}
      </div>
    </div>
  );
};

export default PromptToSync; */

const PromptToSync = ({ closeModal, must = null }) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [storeIsSyncing, setStoreIsSyncing] = useState(false);
  const [syncPercentage, setSyncPercentage] = useState("0%");
  const [initialCount, setInitialCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let initailCount = useRef(null); // to store the initial count of the queue

  const { count, _ } = useSelector((state) => state.offlineQueue);

  // dont mount if count is 0

  useEffect(() => {
    console.log(initailCount.current);

    if (initailCount.current === null) {
      console.log("setting initial count");

      initailCount.current = count;
    } else {
      let percentDegress = ((initailCount.current - count) / initailCount.current) * 100;
      setSyncPercentage(`${parseInt(Math.max(percentDegress, 0))}%`);
    }
  }, [count]);

  useEffect(() => {
    if (syncPercentage === "100%") {
      let prgressBar = document.querySelector(".prograssFIl");
      prgressBar.addEventListener("transitionend", () => {
        closeModal(false);
        setIsLoading(false);
      });
    }
  }, [syncPercentage]);

  const handleSyn = async () => {
    setIsSyncing(true);
    setIsLoading(true);
    setStoreIsSyncing(true);
    const res = await syncOfflineQueue();
    if (res.success) {
      uiAlert(res.message, "success");
      setIsSyncing(false);
      setStoreIsSyncing(false);
    } else {
      setIsSyncing(false);
      setStoreIsSyncing(false);
      uiAlert(res.message, "error");
    }
  };

  /*  const handleSync = () => {
    setIsSyncing(true);
    // Simulate sync process
    setTimeout(() => {
      setIsSyncing(false);
      onSync();
    }, 2000);
  }; */

  /*  if (!isOpen) return null; */

  return (
    <div className='sync-overlay-backdrop'>
      <div className='sync-overlay-modal'>
        {/* Close Button */}
        <button className='sync-overlay-close' onClick={() => closeModal(false)} disabled={isSyncing}>
          <X className='sync-close-icon' />
        </button>

        {/* Header with Notification Badge */}
        <div className='sync-overlay-header'>
          {must ? (
            <div className='sync-notification-badge'>
              <span className='sync-badge-count'> {count} </span>
              <span className='sync-badge-text'>transactions must be synced before continuing</span>
            </div>
          ) : (
            <div className='sync-notification-badge'>
              <span className='sync-badge-count'>{count} </span>
              <span className='sync-badge-text'>transactions needs to sync</span>
            </div>
          )}
        </div>

        {/* Sync Illustration */}
        <div className='sync-illustration-container'>
          <div className={`sync-device-group ${isSyncing ? "syncing" : ""}`}>
            <div className='sync-device sync-device-left'>
              <div className={`sync-device-screen ${isSyncing ? "uploading" : ""}`}>
                <Upload className='sync-device-icon' />
              </div>
              <div className='sync-device-base'></div>
            </div>

            <div className='sync-arrow-container'>
              <div className='sync-arrow'>
                <div className='sync-arrow-line'></div>
                <div className='sync-arrow-head'></div>
              </div>
            </div>

            <div className='sync-device sync-device-right'>
              <div className={`sync-device-screen ${isSyncing ? "downloading" : ""}`}>
                <Download className='sync-device-icon' />
              </div>
              <div className='sync-device-base'></div>
            </div>
          </div>
        </div>

        {/* Progress Section */}
        {/*   <div className='sync-progress-section'>
          <div className={`sync-progress-text ${isSyncing ? "syncing" : ""}`}>{isSyncing ? "synchronizing..." : "synchronize 0%"}</div>
          <div className='sync-progress-bar'>
            <div className={`sync-progress-fill ${isSyncing ? "active" : ""}`}></div>
          </div>
        </div> */}
        <div className='progressBarWrapper'>
          <div className='progressBarSync'>
            <div
              style={{
                width: `${syncPercentage}`,
              }}
              className='prograssFIl'
            ></div>
          </div>
          <p>synchronize {syncPercentage} </p>
        </div>

        {/* Action Buttons */}
        <div className='sync-actions'>
          {count ? (
            <button className='sync-btn-primary' onClick={handleSyn} disabled={isSyncing}>
              <span>{isSyncing ? "Synchronizing..." : "Synchronize transactions now"}</span>
              <Upload className='sync-btn-icon' />
            </button>
          ) : (
            <button className='sync-btn-primary' style={{ opacity: "0,7" }} disabled={true}>
              <span>{isSyncing ? "Synchronizing..." : "Synchronize transactions now"}</span>
              <Upload className='sync-btn-icon' />
            </button>
          )}

          {must ? (
            <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='sync-btn-secondary' disabled={true}>
              Do it later
            </button>
          ) : (
            <button className='sync-btn-secondary' onClick={() => closeModal(false)} disabled={isSyncing}>
              Do it later
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromptToSync;
